import { Node } from '@xyflow/react';
import {
  SensorTrihowSpecificNodeType,
  SensorButtonNodeType,
  SensorBuzzerNodeType,
} from '../Nodes/types';

type SensorsUpdate = {
  buttons: string[];
  buzzers: string[];
  trihows: string[];
};

export function cleanUpSelectedSensors(
  nodes: Node[],
  deletedNodes: Node[],
  currentSelectedSensors: SensorsUpdate,
): {
  sensorsUpdate: SensorsUpdate;
  nodesUpdate: Node[] | null;
} {
  let sensorsUpdate: SensorsUpdate = {
    buttons: [...currentSelectedSensors.buttons],
    buzzers: [...currentSelectedSensors.buzzers],
    trihows: [...currentSelectedSensors.trihows],
  };
  let nodesUpdate: Node[] | null = null;

  const isLastSwitchLanguage =
    nodes.filter((node) => node.type === 'action-switchLanguage').length === 1;
  deletedNodes.forEach((node) => {
    if (node.type === 'sensor-nfcSpecific') {
      const nfcSpecfic = node as SensorTrihowSpecificNodeType;
      const selectedTriggerIds = nfcSpecfic.data.options.trihow?.map(
        (t) => t.triggerId,
      );
      sensorsUpdate = {
        ...sensorsUpdate,
        trihows: sensorsUpdate.trihows.filter(
          (trihow) => !selectedTriggerIds?.includes(trihow),
        ),
      };
    } else if (node.type === 'sensor-button') {
      const button = node as SensorButtonNodeType;
      const selectedTriggerIds = button.data.options.buttons?.map(
        (b) => b.triggerId,
      );
      sensorsUpdate = {
        ...sensorsUpdate,
        buttons: sensorsUpdate.buttons.filter(
          (b) => !selectedTriggerIds?.includes(b),
        ),
      };
    } else if (node.type === 'sensor-buzzer') {
      const buzzer = node as SensorBuzzerNodeType;
      const selectedTriggerIds = buzzer.data.options.buzzers?.map(
        (b) => b.triggerId,
      );
      sensorsUpdate = {
        ...sensorsUpdate,
        buzzers: sensorsUpdate.buzzers.filter(
          (b) => !selectedTriggerIds?.includes(b),
        ),
      };
    } else if (node.type === 'action-switchLanguage' && isLastSwitchLanguage) {
      // If the last switchLanguage node is deleted, reset the language in all sensor nodes
      nodesUpdate = nodes.map((lastnode) => {
        if (
          lastnode.type === 'sensor-button' ||
          lastnode.type === 'sensor-buzzer' ||
          lastnode.type === 'sensor-touch' ||
          lastnode.type === 'sensor-nfcSpecific'
        ) {
          return {
            ...lastnode,
            data: {
              ...lastnode.data,
              options: {
                // Preserve existing options but reset language
                // type stuff here check if options is an object to spread it
                ...(typeof lastnode.data.options === 'object' &&
                lastnode.data.options !== null
                  ? lastnode.data.options
                  : {}),
                language: null,
              },
            },
          };
        }
        return lastnode;
      });
    }
  });

  return { sensorsUpdate, nodesUpdate };
}
